import { FormType, isUndefined } from '@aloft/toolkit-shared';

import { ClickFormsExisting, ExportType } from '../types.ts';

export const exportIsDisabled = (
  exportType: ExportType | undefined,
  clickFormsExisting: ClickFormsExisting | undefined,
  formType: FormType | undefined,
  exportClicked: boolean,
) => {
  if (exportClicked) return true;

  switch (exportType) {
    case 'appraise-it':
      return isUndefined(formType);
    case 'click-forms':
      return isUndefined(clickFormsExisting) || isUndefined(formType);
    case 'pdf':
      return false;
    case 'total':
      return isUndefined(formType);
    default:
      return true;
  }
};
